module.exports = __webpack_public_path__ + "img/taipei-mox-01.ec7d1bdb.jpg";